export const validatePalletBarcode = (barcode: string) => /^(IBP[0-9a-zA-Z]{10}|PID[A-Z0-9]{7})$/gi.test(barcode);
